import * as React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

//Assets
import { Link } from "react-router-dom";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import { SHOPIFY_URL } from "../../utils/shopify.utils";
import CartButton from "../../components/Buttons/CartButton";
import ContainedButton from "../../components/Buttons/ContainedButton";
import logo from "../../assets/images/Logo.svg";

const WhyEvrbedHeader = ({
  showBuildMyBed,
  showCart,
  cartIconColor,
  logoColums,
  styles = {},
}) => {
  const theme = useTheme();
  let navigate = useNavigate();
  const { t } = useTranslation();
  const classes = logoColums || "col-1";
  return (
    <header
      style={{
        // background: `rebeccapurple`,
        // marginBottom: "1.45rem",
        height: "10vh",
      }}
    >
      <div
        className="row"
        style={{
          margin: "0 auto",
          padding: "1rem",
        }}
      >
        <Box className={classes} sx={{}}>
          <Link to="/" style={{}}>
            <img style={{ marginBottom: 0 }} src={logo}></img>
          </Link>
        </Box>
        <div className="col-2">
          <div className="row flex align-items-center justify-content-end">
            {showBuildMyBed && (
              <ContainedButton
                className="col-auto"
                onClick={() =>
                  (window.top.location.href =
                    SHOPIFY_URL + "pages/mattress-builder")
                }
              >
                {t("BUILD MY BED")}
              </ContainedButton>
            )}
            {showCart && (
              <CartButton
                cartIconColor={cartIconColor}
                className="col-auto"
              ></CartButton>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

WhyEvrbedHeader.propTypes = {
  siteTitle: PropTypes.string,
};

WhyEvrbedHeader.defaultProps = {
  siteTitle: "",
};

export default WhyEvrbedHeader;
